/* assets/custom.js – reveal Loox button 5 s after it appears */
document.addEventListener('DOMContentLoaded', () => {
  const SELECTOR     = '.loox-float-toggler';
  const SHOW_DELAY   = 5000;   // ms  (5 s)
  const POLL_EVERY   = 500;     // ms  between checks
  const GIVE_UP_MS   = 20000;  // ms  stop polling after 20 s

  let waited = 0;

  const poll = setInterval(() => {
    waited += POLL_EVERY;
    const el = document.querySelector(SELECTOR);

    if (el) {
      
      clearInterval(poll);                      // found it
      setTimeout(() => {
        el.style.visibility = 'visible';        // reveal
        // If Loox later re-inserts the element you’d need to poll again
        // or swap this whole loop for a MutationObserver.
        
      }, SHOW_DELAY);
    } else if (waited >= GIVE_UP_MS) {
      clearInterval(poll);                      // give-up guard
    
      
    }
  }, POLL_EVERY);
});
